import { AppState } from '..'
import { useAppSelector } from './../hooks'

export const getContractKeySharingKeys = (contractAddress: string) => {
  return useAppSelector(
    (state: AppState) => state.keySharing.keys[contractAddress]
  )
}
